import { Flex, HStack, Text } from "@chakra-ui/react";
import { getFormatDateAsDateMonth, getFormatTime } from "@utils/dateUtils";
import { BreakTimeList } from "@constants/createOrder";

interface Props {
	end: string;
	start: string;
	flexible?: boolean;
	break?: number;
}

const ShiftSummaryItem = (props: Props) => {
	return (
		<Flex
			direction={"row"}
			justify={"space-between"}
			width={{ base: "full", xl: "80%" }}
			borderRadius={"18px"}
			p={3}
			borderColor={"#E6E6E6"}
			borderWidth={"1px"}
			fontSize={{ base: "sm", md: "md" }}
		>
			<Text textTransform="capitalize" fontWeight={"semibold"} my={0} width={"35%"}>
				{getFormatDateAsDateMonth(props.start)}
			</Text>
			<HStack width={"45%"}>
				<Text fontWeight={400} my={0}>
					{`${getFormatTime(props.start)} - ${getFormatTime(props.end)}`}
				</Text>
				{props.flexible && (
					<Text fontWeight={400} my={0} color={"#999999"}>
						{"(Flexibel starttid)"}
					</Text>
				)}
			</HStack>
			<Text width={"20%"} fontWeight={400} my={0}>
				{`Rast: ${props.break !== undefined && props.break !== null ? BreakTimeList.find((item) => item.key === props.break?.toString())?.value || 0 : 0} min`}
			</Text>
		</Flex>
	);
};

export default ShiftSummaryItem;
